import Cookies from "js-cookie";

export default class {
	constructor(cookieName, expires = 365, value = true) {
		this.cookieName = cookieName;
		this.value = value;
		this.expires = expires;

		if (window.location.search.includes("utm_source=wifi-splash")) {
			this.setCookie();
		}
	}

	hasCookie() {
		return Cookies.get(this.cookieName);
	}

	setCookie() {
		Cookies.set(this.cookieName, this.value, { expires: this.expires });
	}
}
